export default __webpack_public_path__ + "static/media/019-no entry.31309892.png";